import { useCallback, useRef } from "react";
import { type BlockerFunction, useBlocker } from "react-router-dom";

/** Cover in-app links and history navigation; document unloads are guarded by the form. */
export function useTicketIntakeNavigation(hasUnsavedWork: boolean) {
  const navigationAllowed = useRef(false);
  const blocker = useBlocker(
    useCallback<BlockerFunction>(
      ({ currentLocation, nextLocation }) => !navigationAllowed.current && hasUnsavedWork && currentLocation.pathname !== nextLocation.pathname,
      [hasUnsavedWork],
    ),
  );

  const allowNavigation = useCallback(() => {
    // Submission can navigate before the cleared dirty state has rendered.
    navigationAllowed.current = true;
  }, []);

  return { blocker, allowNavigation };
}
